const state = {
	items: [],
	shipping: null,
	country: null,
	payment: null,
	coupon: null,
	is_spin_win_coupon: false,
	subtotal: 0,
	total: 0,
	total_payment: 0,
	coupon_discount: 0,
	checkoutStatus: null,
	cartLoaded: false,
	current: {
		amount: null,
		length: null,
		product_id: null
	},
}

// getters
const getters = {
	cartSize: (state, getters, rootState) => {
		return state.items ? state.items.length : 0;
	},
	cartProducts: (state, getters, rootState) => {
		return state.items;
	},
	cartTotals: (state, getters, rootState) => {
		return {
			subtotal: state.subtotal,
			total: state.total,
			total_payment: state.total_payment
		};
	},
	cartExtras: (state, getters, rootState) => {
		return {
			shipping: state.shipping,
			payment: state.payment,
			coupon: state.coupon,
			is_spin_win_coupon: state.is_spin_win_coupon
		};
	},
	currentProduct: (state, getters, rootState) => {
		return {
			amount: state.current.amount,
			length: state.current.length,
			product_id: state.current.product_id
		};
	},
}

// actions
const actions = {
	loadCart ({ state, commit, rootState }, data) {
		if (!state.cartLoaded) {
			data = {
				lang: current_locale ?? 'en'
			}
			axios
				.post('/api/cart/get', data)
				.then(response => {
					commit('updateCart', response.data);
					commit('setCartLoaded');
				})
				.catch(error => console.log(error));
		}
	},
	addToCart({ state, commit, rootState}, data) {
		return axios
			.post('/api/cart/add', data)
			.then(response => commit('updateCart', response.data))
			.catch(error => console.log(error));
	},
	removeFromCart({ state, commit, rootState }, data) {
		axios
			.post('/api/cart/remove', {
				item: data
			})
			.then(response => commit('updateCart', response.data))
			.catch(error => console.log(error));
	},
	updateCart({ state, commit, rootState }, data) {
		return new Promise((resolve, reject) => {
			axios
				.post('/api/cart/update', data)
				.then(response => {
					commit('updateCart', response.data);
					resolve(response);
				}).catch(error => console.log(error));
		}, error => {
			// http failed, let the calling function know that action did not work out
			reject(error);
		});
	},
	clearCart({ state, commit, rootState }, data) {
		axios
			.post('/api/cart/clear')
			.then(response => commit('updateCart', response.data))
			.catch(error => console.log(error));
	},
	setShipping({state, commit, rootState}, data) {
		return axios
			.post('/api/cart/shipping', data)
			.then(response => commit('updateCart', response.data))
			.catch(error => console.log(error));
	},
	setPayment({state, commit, rootState}, data) {
		return axios
			.post('/api/cart/payment', data)
			.then(response => commit('updateCart', response.data))
			.catch(error => console.log(error));
	},
	setCoupon({state, commit, rootState}, data) {
		return axios
			.post('/api/cart/coupon', data)
			.then(response => {
				commit('updateCart', response.data.cart)
				return {error: response.data.error, description: response.data.description};
			})
			.catch(error => console.log(error));
	},
	setCurrent({state, commit, rootState}, data) {
		commit('updateProduct', data)
	},
	resetCountry({state, commit, rootState}) {
		commit('clearCountry')
	},
	setIsSpinWinCoupon({state, commit, rootState}, data) {
		commit('updateIsSpinWinCoupon', data)
	}
}

// mutations
const mutations = {
	setCartLoaded(state) {
		state.cartLoaded = true;
	},
	updateIsSpinWinCoupon(state, data) {
		state.is_spin_win_coupon = data.is_spin_win_coupon;
	},
	updateCart(state, data) {
		state.items = data.items;
		state.total = data.total;
		state.subtotal = data.subtotal;
		state.total_payment = data.total_payment;
		state.coupon_discount = data.coupon_discount;

		state.country = data.country;
		state.shipping = data.shipping;
		state.payment = data.payment;
		state.coupon = data.coupon;
		state.is_spin_win_coupon = data.is_spin_win_coupon;
	},
	updateProduct(state, data) {
		state.current = data;
	},
	clearCart(state) {
		state.items = []
		state.shipping = null
		state.country = null
		state.payment = null
		state.coupon = null
		state.is_spin_win_coupon = false
		state.subtotal = 0
		state.total = 0
		state.total_payment = 0
		state.coupon_discount = 0
		state.checkoutStatus = null
		state.cartLoaded = false
	},
	clearCountry(state) {
		state.country = null
		state.shipping = null
	}

}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
